"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.GRID_VIEW_COLUMNS, (table)=>{
        table.boolean('group_by');
        table.float('group_by_order');
        table.string('group_by_sort');
    });
};
const down = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.GRID_VIEW_COLUMNS, (table)=>{
        table.dropColumn('group_by');
        table.dropColumn('group_by_order');
        table.dropColumn('group_by_sort');
    });
};
